import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'

export const LoginCardSurface = styled(Paper)(({ theme }) => ({
  width: '100%',
  maxWidth: 420,
  overflow: 'hidden',
  backgroundColor: theme.palette.grey[900],
  boxShadow: '0 22px 48px rgba(0, 0, 0, 0.22)',
}))
